export default "__VITE_ASSET__NV9dfnhX__"